// Currency.js
export const SET_CURRENCY_NAME = 'SET_CURRENCY_NAME'
export const SET_CURRENCY_RATE = 'SET_CURRENCY_RATE'
export const SET_CURRENCY_SYMBOL = 'SET_CURRENCY_SYMBOL'

// UI.js
export const SET_UI_LANGUAGE = 'SET_UI_LANGUAGE'
export const SET_UI_NIGHT_MODE = 'SET_UI_NIGHT_MODE'
export const SET_UI_HEADER_TYPE = 'SET_UI_HEADER_TYPE'
export const SET_UI_MENU_VISIBLE = 'SET_UI_MENU_VISIBLE'
export const SET_UI_PRICE_CHART = 'SET_UI_PRICE_CHART'

// Delegates.js
export const SET_DELEGATES = 'SET_DELEGATES'
export const SET_FORGED = 'SET_FORGED'

// Network.js
export const SET_NETWORK_DEFAULTS = 'SET_NETWORK_DEFAULTS'
export const SET_NETWORK_SERVER = 'SET_NETWORK_SERVER'
export const SET_NETWORK_TOKEN = 'SET_NETWORK_TOKEN'
export const SET_NETWORK_SYMBOL = 'SET_NETWORK_SYMBOL'
export const SET_NETWORK_NETHASH = 'SET_NETWORK_NETHASH'
export const SET_NETWORK_CURRENCIES = 'SET_NETWORK_CURRENCIES'
export const SET_NETWORK_KNOWN_WALLETS = 'SET_NETWORK_KNOWN_WALLETS'
export const SET_NETWORK_SUPPLY = 'SET_NETWORK_SUPPLY'
export const SET_NETWORK_HEIGHT = 'SET_NETWORK_HEIGHT'
export const SET_NETWORK_ALIAS = 'SET_NETWORK_ALIAS'
export const SET_NETWORK_ACTIVE_DELEGATES = 'SET_NETWORK_ACTIVE_DELEGATES'
export const SET_NETWORK_REWARD_OFFSET = 'SET_NETWORK_REWARD_OFFSET'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js